module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level-block"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading clearfix",
    class: {
      'error': _vm.menu.errorMessage
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.levelClick(_vm.menu)
      }
    }
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.menu.name ? _vm.menu.name : "请填写菜单名称") + "\n\t\t\t\t")]), _vm._v(" "), (_vm.menu.type === 'ARTICLE' || _vm.menu.type === 'PERSON' || _vm.menu.type === 'SCENERY' || _vm.menu.type === 'PARENT') ? _c('span', {
    staticClass: "ml10"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.menu.getUrlBase())), _c('span', {
    staticClass: "label-attribute"
  }, [_vm._v(_vm._s(_vm.menu.location))])]) : _vm._e(), _vm._v(" "), (_vm.menu.type === 'TOPIC') ? _c('span', {
    staticClass: "ml10 label-link"
  }, [_c('i', {
    staticClass: "fa fa-ravelry"
  }), _vm._v("\n\t\t\t\t\t/" + _vm._s(_vm.menu.topic.location) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.menu.type === 'URL') ? _c('span', {
    staticClass: "ml10 label-topic"
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.menu.url) + "\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('ActionButtons', {
    attrs: {
      "index": _vm.index,
      "menu": _vm.menu,
      "container": _vm.container,
      "editMode": _vm.editMode
    }
  })], 1)]), _vm._v(" "), _c('NbExpanding', [(_vm.menu.editMode) ? _c('PanelBody', {
    attrs: {
      "menu": _vm.menu,
      "container": _vm.container
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm._l((_vm.menu.menus), function(attr, attrIndex) {
    return _c('LevelBlock', {
      key: attr,
      attrs: {
        "menu": attr,
        "index": attrIndex,
        "container": _vm.menu.menus,
        "editMode": _vm.editMode
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-dde0fb56"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/topic/widget/LevelBlock.vue
// module id = 1030
// module chunks = 1